import styled from 'styled-components';
//import background from '../../images/backgroundlogin.jpg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #262627;
  align-items: center;
`;

export const Imagem = styled.img`
  margin-bottom: 40px;
`;
